<script>
  import { ignore, makeWebsiteRequest } from "../../Common/tools";
  import { onMount } from "svelte";
  import Table from "../../Table/Table.svelte";
  import ActiveColumns from "../../Contacts/Common/ActiveColumns.svelte";
  import ListPicker from "../../Popups/ListPicker.svelte";
  import {External, M} from "../../external";

  export let data,
    filters,
    filteringBy,
    onEmptyAction = ignore;

  let allItems = null;
  let activeColumns = null;

  let selection = null;
  let loading = true;
  let initialLoad = true;
  let currentPage = 0;
  let pagesCount = 0;
  let table = null;
  let timeColumns = [];
  let helpVideoMarkup = "";

  let order = "id";
  let orderDirection = "asc";

  let tableData = {
    columns: [],
    rows: []
  };

  let loadColumns = () => {
    if (!tableData.columns.length) {
      activeColumns = External.WebPlatform.getObjectFromLocalStorage("marketingContactColumns", []);
      if (!activeColumns.length) {
        activeColumns = [-1, -2];
      }

      let count = 0;
      let columns = [];
      timeColumns = [];
      activeColumns.forEach(function (column) {
        let prop = External.getById(External.Website.crmProperties, column);
        if (prop) {
          let key = "col" + count++;
          columns.push({
            key: key,
            label: prop.label,
            class: prop.id === -1 ? "flex-1 mw-240" : "flex-none",
            id: column,
            sortable: true
          });

          if (prop.type === "DATE") {
            timeColumns.push(key);
          }
        } else {
          switch (column) {
            case "created":
              columns.push({
                key: column,
                label: M.CREATED,
                class: "flex-none",
				        id: 'created',
                sortable: true
              });
              timeColumns.push(column);
              break;
            case "tags":
              columns.push({
                key: column,
                label: M.TAGS,
                class: "flex-none"
              });
              break;
          }
        }
      });

      columns.push({
        key: "open",
        label: M.OPEN_RATE,
        type: "percent",
        rowClass: "pay-status paid",
        class: "flex-none mw-140",
      });

      columns.push({
        key: "click",
        label: M.CLICK_RATE,
        type: "percent",
        rowClass: "order-status pending",
        class: "flex-none mw-140"
      });

      tableData.columns = columns;
    }
  };

  let load = async (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;

    if (page === 0) {
      loadColumns();
      tableData.rows = [];
    } else if (currentPage + 1 >= pagesCount) {
      return;
    }
    loading = true;

    let request = {
      page: page,
      columns: JSON.stringify(activeColumns),
      filteringBy: filteringBy,
	  order: order,
	  orderDirection: orderDirection,
    };

    if (filters.length > 0) {
      request.filters = JSON.stringify(filters);
    }

    let response = await makeWebsiteRequest({
      action: "listSubscribers",
      method: "get",
      data: request
    });

    loading = false;
    if (!response.data) return;

    currentPage = page;
    data.count = response.data.count;
    pagesCount = response.data.pagesCount;
    allItems = data.count;

    if (timeColumns && timeColumns.length) {
      response.data.items.forEach(function (item) {
        timeColumns.forEach(function (column) {
          let value = item[column];
          if (value) {
            if (column !== "created") {
              value = value * 1000; // creted is in milliseconds where date properties are in unix seconds
            }
            item[column] = External.Tools.dateToString(new Date(value), false);
          } else {
            item[column] = "";
          }
        });
      });
    }

    if (table) table.addRows(response.data.items);
  };

  let getSelectedItemsCount = () => {
    if (selection !== null) {
      if (selection.all) return allItems - selection.unselected.length;
      else return selection.selected.length;
    }
    return allItems;
  };

  export function onReloadData() {
    load(0);
  }

  export function changeTags(add) {
    External.UITools.selectTagsExt({
      onTagsSelected: (tags) => {
        if (tags.length === 0) {
          return;
        }
        const selected = tags[0];
        const itemsToTag = getSelectedItemsCount();
        const message = escapeFormat(add ? M.ADD_TAG_CONTACTS : M.REMOVE_TAG_CONTACTS, 'label', selected.label, 'count', itemsToTag);
        Tools.prompt(M.TAG + ' ' + itemsToTag + ' ' + (allItems === 1 ? M.CONTACT : M.CONTACTS), message, () => {
          Tools.makeWebsiteRequest({
            action: add ? 'addTag' : 'removeTag',
            method: 'post',
            data: {
              tag: selected.id,
              filter: JSON.stringify(filters),
              selection: JSON.stringify(selection),
              subscribedOnly: true
            },
            onOk: () => {
              load(0);
            }
          });
        }, ignore, M.YES, M.NO);
      },
      allowEmptySelection: true,
      single: true,
      message: M.SELECT_TAGS2
    });
  };

  const changeContactLists = (add) => {

    let componentData = {};

    if (selection == null || (!selection.all && selection.selected.length === 0)) {
      Tools.showError(M.SELECT_CONTACTS);
      return;
    }

    Tools.showWindow({
      noTitle: true,
      isModal: true,
      width: 400,
      buttons: [
        Button(M.SAVE, Button.CLASS_MIDDLE_BLUE, function (popup, context) {
          if (componentData.list === "") {
            Tools.showError(M.SELECT_LIST);
            return;
          }
          Tools.makeWebsiteRequest({
            action: add ? 'addContactsToList' : 'removeContactsFromList',
            method: 'post',
            data: {
              filter: JSON.stringify(filters),
              selection: JSON.stringify(selection),
              listId: componentData.list,
              subscribedOnly: true
            },
            onOk: function () {
              Tools.showSaveSuccessWindow();
              popup.close();
              load(0);
            }
          });
        }),
        Button.MIDDLE_CLOSE
      ],
      markup: '<div class="popup-widget-wrapper"></div>',
      action: {
        onShow: function (popup, context) {
          popup.bindComponent(WebComponents.Marketing.listPicker(context.find('.popup-widget-wrapper')[0], componentData, false, M.CHOOSE_SUBSCRIBER_LIST_REMOVE));
        }
      }
    });
  };

  export function showMoreOptions(event) {
    let items = [
      {
        icon: "fa-upload",
        label: M.IMPORT,
        tag: "import"
      },
      {
        icon: "fa-download",
        label: M.EXPORT,
        tag: "export"
      },
      {
        icon: 'fa-list-alt',
        label: M.ADD_CONTACTS_TO_LIST,
        tag: 'add-to-list'
      },
      {
        icon: 'fa-list-alt',
        label: M.REMOVE_CONTACTS_FROM_LIST,
        tag: 'remove-from-list'
      },
      {
        icon: 'fa-tag',
        label: M.REMOVE_A_TAG,
        tag: 'remove-tag'
      },
      {
        icon: "fa-minus",
        label: M.CONTACT_UNSUBSCRIBE,
        tag: "unsubscribe"
      }/*,
      {
        icon: "fa-trash",
        label: M.DELETE,
        tag: "delete"
      }*/
    ];

    External.Tools.showFloatingPopupList({
      target: External.$(event.target).closest("a"),
      items: items,
      onSelect: function (selected) {
        if (selected.tag === "export") {
          let itemsToExport = getSelectedItemsCount();
          let message = External.escapeFormat(M.EXPORT_COUNT, "count", itemsToExport);
          External.Tools.prompt(
            M.EXPORT + " " + itemsToExport + " " + (allItems === 1 ? M.CONTACT : M.CONTACTS),
            message,
            function () {
              let params = {
                filter: filters,
                selection: selection,
                subscribedOnly: true
              };
              External.CPanel.initiateExport("EXPORT_CONTACTS", params, M.CONTACTS_EXPORT_IN_PROGRESS);
            },
            ignore,
            M.YES,
            M.NO
          );
        } else if (selected.tag === "delete") {
          let itemsToDelete = getSelectedItemsCount();
          let message = External.escapeFormat(M.DELETE_CONTACTS, "count", itemsToDelete);
          External.Tools.prompt(
            M.DELETE + " " + itemsToDelete + " " + (allItems === 1 ? M.CONTACT : M.CONTACTS),
            message,
            function () {
              External.Tools.makeWebsiteRequest({
                action: "deleteContacts",
                method: "post",
                data: {
                  filter: JSON.stringify(filters),
                  selection: JSON.stringify(selection)
                },
                onOk: function () {
                  load(0);
                }
              });
            },
            ignore,
            M.YES,
            M.NO
          );
        } else if (selected.tag === "import") {
          //import in a specific list
          if (filters.length === 1 && filters[0].length === 1 && filters[0][0].type === External.CRM_FILTER_TYPE.SUBSCRIBER_LIST) {
            External.CSVContactsImporter().start(filters[0][0].id);
            return;
          }

          const buttons = [
            External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup, context) {
              let formData = popup.component().get();

              if (formData.list === "") {
                External.Tools.showError(M.SELECT_LIST_FIRST);
                return;
              }

              External.CSVContactsImporter().start(formData.list);
              popup.close();
            }),
            External.Button.MIDDLE_CLOSE
          ];
          External.Tools.showWindow({
            isModal: false,
            width: 500,
            buttons: buttons,
            markup: '<div class="popup-widget-wrapper"></div>',
            action: {
              onShow: function (popup, context) {
                popup.bindComponent(
                  new ListPicker({
                    target: context.find(".popup-widget-wrapper")[0],
                    props: {
                      showNewListButton: true,
                      data: {}
                    }
                  })
                );
              }
            }
          });
        } else if (selected.tag === 'unsubscribe') {
          let toUnsubscribe = getSelectedItemsCount();
          External.Tools.prompt(M.CONTACT_UNSUBSCRIBE, External.format(M.CONTACT_UNSUBSCRIBE_MESSAGE, 'x', toUnsubscribe),
                  function () {
                    External.Tools.makeWebsiteRequest({
                      action: "changeSubscribeStatusBulk",
                      method: "post",
                      data: {
                        filter: JSON.stringify(filters),
                        selection: JSON.stringify(selection)
                      },
                      onOk: function () {
                        load(0);
                      }
                    });
                  },
                  function () {
                    // do nothing - cancelled!
                  },
                  M.YES,
                  M.NO
          );
        } else if (selected.tag === 'remove-tag') {
          changeTags(false);
        } else if (selected.tag === 'add-to-list') {
          changeContactLists(true);
        } else if (selected.tag === 'remove-from-list') {
          changeContactLists(false);
        }
      }
    });
  }

  export function showColumnOptions(event) {
    let columnItems = [];
    External.Website.crmProperties.forEach(function (property) {
      columnItems.push({
        id: property.id,
        label: property.label,
        disabled: property.id === -1 || property.id === -2, // name or email
        checked: activeColumns.indexOf(property.id) > -1
      });
    });

    columnItems.push({
      id: "tags",
      label: M.TAGS,
      checked: activeColumns.indexOf("tags") > -1
    });

    columnItems.push({
      id: "created",
      label: M.CREATED,
      checked: activeColumns.indexOf("created") > -1
    });

    External.Tools.showFloatingPopup({
      markup: '<div class="col20 f-left bound-popup"></div>',
      width: 250,
      target: External.$(event.target).closest("a"),
      customClass: "crm-filter-value",
      action: {
        onShow: function (popup, ui) {
          popup.bindComponent(
            new ActiveColumns({
              target: ui.find(".bound-popup")[0],
              props: {
                data: columnItems,
                change: function () {
                  let newColumns = [];
                  columnItems.forEach(function (column) {
                    if (column.checked) {
                      newColumns.push(column.id);
                    }
                  });
                  if (newColumns.indexOf(-1) < 0) {
                    newColumns.unshift(-1);
                  }
                  if (newColumns.indexOf(-2) < 0) {
                    newColumns.unshift(-2);
                  }

                  activeColumns = newColumns;
                  External.WebPlatform.setObjectToLocalStorage("marketingContactColumns", activeColumns);
                  tableData.columns = [];
                  load(0);
                }
              }
            })
          );
        }
      }
    });
  }

  let onClick = (row) => {
    External.CPanel.goToUrl("/me/crm/contact/" + row.id + "?tab=marketing", true);
  };

  let onNext = () => {
    load(currentPage + 1);
  };

  let onOrder = (event) => {
    if (event === null) {
      order = "id";
      orderDirection = "asc";
    } else {
	  orderDirection = event.dir;
      order = event.column.id;
    }
    load(0);
  }

  onMount(() => {
    // ignore, data is loaded in onReloadData
    if (External.Website.onboarding && External.Website.onboarding.marketingSubscribers) {
      helpVideoMarkup = External.CPanel.getEmbedVideo(External.Website.onboarding.marketingSubscribers);
    }
  });
</script>

<Table bind:this={table} activeColumns={tableData.columns} data={tableData.rows} loading={loading} bind:selection onClick={onClick} nextPage={onNext} onOrder={onOrder}>
  <div class="text-center col20 f-left" style="padding: 70px 30px; box-sizing: border-box;">
    <h3 class="col20 f-left t-center mb-15">{M.NO_SUBSCRIBERS_AVAILABLE}</h3>
    <div class="col20 f-left t-center">
      <a class="middle-button blue with-icon inline-block f-none" on:click={onEmptyAction}>
        {M.ADD_SUBSCRIBERS}
      </a>
    </div>
    {#if helpVideoMarkup}
      <div class="col20 f-left mt-25">
        <div style="max-width: 600px; margin: 0 auto; display: block;">
          <div class="col20 f-left" style="padding:56.25% 0 0 0;position:relative;">
            <div class="full-size-abs" style="top: 0; left: 0">
              {@html helpVideoMarkup}
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>
</Table>
